import React from 'react';
import { Link } from 'react-router-dom';
import { useWallet } from '../hooks/useWallet';
import TransactionList from '../components/TransactionList/TransactionList';
import Button from '../components/common/Button';
import TransactionSkeleton from '../components/skeletons/TransactionSkeleton/TransactionSkeleton';

const TransactionsPage = () => {
  const { wallet, loading } = useWallet();

  if (loading) {
    return <TransactionSkeleton />;
  }

  if (!wallet) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            No Wallet Found
          </h2>
          <p className="text-gray-600 mb-4">
            Please set up a wallet first to view transactions.
          </p>
          <Link to="/">
            <Button variant="primary">Go to Home</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="container mx-auto py-8">
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              {wallet.name} - Transactions
            </h1>
            <p className="text-gray-600">
              Current Balance: ₹{parseFloat(wallet.balance).toFixed(4)}
            </p>
          </div>
          <Link to="/">
            <Button variant="secondary">Back to Wallet</Button>
          </Link>
        </div>

        <TransactionList walletId={wallet.id} />
      </div>
    </div>
  );
};

export default TransactionsPage;
